<template>
  <div class="pt-48 md:pt-80">
    <corporate-header />
    <corporate-hero ref="corporateHero" />
    <premium-section />
    <trust-and-safety-section />
    <bright-horizons-section />
    <sign-up-section @sign-up-click="$refs.corporateHero.signUpClick()" />
  </div>
</template>

<script lang="ts">
import CorporateHero from './components/CorporateHero.vue';
import PremiumSection from './components/PremiumSection.vue';
import CorporateHeader from './components/CorporateHeader.vue';
import TrustAndSafetySection from './components/TrustAndSafetySection.vue';
import SignUpSection from './components/SignUpSection.vue';
import BrightHorizonsSection from './components/BrightHorizonsSection.vue';

export default {
  name: 'Generic',
  components: {
    CorporateHero,
    PremiumSection,
    CorporateHeader,
    TrustAndSafetySection,
    SignUpSection,
    BrightHorizonsSection,
  },
};
</script>
